import { useState as o, useCallback as e } from "react";
export default function (n, t, r) {
  var i = o(n),
      d = i[0],
      l = i[1];
  void 0 !== t && void 0 !== n && console.error("Warning: both `controlledValue` and `defaultValue` have been defined, decide wheter if you desire the component to be controlled or uncontrolled defining only one of the two properties."), void 0 !== t && null == r && console.error("Warning: a `controlledValue` was provided, but a `controlValue` is missing. To update the state of the Hook you will need to define one.");
  var u = e(function (o) {
    "function" == typeof r && r("function" == typeof o ? o(t) : o), l(o);
  }, [t, r]);
  return [function (o, e) {
    return void 0 !== o && void 0 === e;
  }(t, n) ? t : d, u];
}